import styled from 'styled-components';

import { Heading3 } from '@qover/typography';

export const PaymentSuccessContainer = styled(Heading3)`
  align-items: center;
  display: flex;

  svg {
    height: 20px;
    width: 20px;
    margin-right: 10px;
  }
`;

export const SelectedProgram = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 300px;

  small {
    font-size: 11px;
    display: block;
    font-weight: normal;
    text-align: right;
  }
`;
